<div class="main">
    <div class="page-heading">
        <div>
            <span class="eyebrow"><i class="bi bi-exclamation-triangle" aria-hidden="true"></i> Needs attention</span>
            <h1>Faulty Masters</h1>
            <p>Master records with incomplete or invalid data.</p>
        </div>
        <button class="refresh-button" type="button" title="Refresh" aria-label="Refresh Faulty Masters"
                [disabled]="masterService.isTableLoading()" (click)="getFaultyMasters()">
            <i class="bi bi-arrow-clockwise" aria-hidden="true"></i>
        </button>
    </div>
    @if (masterService.isTableLoading() && !masterService.faultyMasters().length) {
        <div class="state-panel" role="status" aria-live="polite">
            <span class="loading-spinner" aria-hidden="true"></span>
            <h2>Loading Faulty Masters…</h2>
            <p>Checking records that need attention.</p>
        </div>
    } @else if (masterService.faultyMastersError() && !masterService.faultyMasters().length) {
        <div class="state-panel" role="alert">
            <span class="state-icon error"><i class="bi bi-exclamation-circle" aria-hidden="true"></i></span>
            <h2>Couldn’t load Faulty Masters</h2>
            <p>Please try again. Your records haven’t been changed.</p>
            <button class="retry-button" type="button" (click)="getFaultyMasters()">Try again</button>
        </div>
    } @else if (!masterService.faultyMasters().length) {
        <div class="state-panel" role="status" aria-live="polite">
            <span class="state-icon"><i class="bi bi-check2-circle" aria-hidden="true"></i></span>
            <h2>No faulty Masters found</h2>
            <p>There are no Master records that need attention right now.</p>
        </div>
    } @else {
        <div class="table-container"
             infinite-scroll
             [scrollWindow]="false"
             [infiniteScrollDistance]="2"
             (scrolled)="masterService.onScrollFaulty()">
            <app-master-records-table [allMasters]="masterService.faultyMasters()"
                                      [sortDirectionValues]="masterService.sortDirectionValues()"
                                      [displayedColumns]="masterService.displayedColumns()"
                                      [expandedMaster]="masterService.expandedMaster()"
                                      [displayedTableHeaders]="masterService.displayedTableHeaders()"
                                      [allVersions]="tuningService.allVersions()"
                                      [displayedVersionColumns]="masterService.displayedVersionColumns()"
                                      (deleteOriginalItem)="deleteFaultyMaster($event)"
                                      (downloadOriginalFile)="downloadFileFromTable($event)"
                                      (deleteTuningRecord)="deleteTuningRecordFromTable($event)"
                                      (downloadTuningRecord)="downloadTuningRecordFromTable($event)"
                                      (editItemDetails)="editItemDetails($event)"
                                      (toggleExpandedRow)="toggleExpandedRow($event)"
                                      (changeSortDirection)="changeSortDirection($event)"
            ></app-master-records-table>
        </div>
        @if (masterService.faultyMastersError()) {
            <div class="page-error" role="alert">More records couldn’t be loaded. <button type="button" (click)="masterService.retryFaultyMastersPage()">Retry</button></div>
        }
    }
</div>
